<script setup lang="ts">
import { storeToRefs } from 'pinia';
import Button from '../../../../_01_atoms/components/Button.vue';
import { trans } from '../../../../_00_elements/translation';
import { useAccountStore } from '../../store/account';

const { stripePortalLink } = storeToRefs(useAccountStore());

const goToStripe = () => {
  window.open(stripePortalLink.value, '_blank');
};
</script>

<template>
  <Button variant="primary" class="update-stripe-payment-method" @click="goToStripe">
    {{ trans('gestion.pay.payment_method.empty_state.cta') }}
    <span class="external-link-icon" />
  </Button>
</template>
